import React from 'react'

import { ShippingDeadlineSection } from './ShippingDeadlineSection'
import { PickupDeadlineSection } from './PickupDeadlineSection'
import type { Package } from '../../../../../../core/typings'

export type DeadlineSectionProps = {
  productPackage: Package
}

export const DeadlineSection = ({ productPackage }: DeadlineSectionProps) => {
  return productPackage.deliveryChannel === 'delivery' ? (
    <ShippingDeadlineSection
      shippingEstimate={productPackage.shippingEstimate}
    />
  ) : (
    <PickupDeadlineSection shippingEstimate={productPackage.shippingEstimate} />
  )
}
